import { IMAGE_LOADER, ImageLoaderConfig } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";

export interface SocialLinks {
    url: string;
    facebook?: string;
    whatsapp?: string;
    instagram?: string;
    linkedin?: string;
    x?: string;
    youtube?: string;
    tiktok?: string;
}

const INFO_BROCHURE_URL = "https://assets.uav.pansa.pl/Plakat_NO_DRONE_ZONE.pdf";

const DRONE_TOWER_APP_STORE_LINK = "https://apps.apple.com/pl/app/dronetower/id6477453743";
const DRONE_TOWER_PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=pl.pansa.dronetower";

export const PATRONS_LINKS = {
    ulc: {
        url: "https://ulc.gov.pl",
        x: "https://x.com/ulc_gov_pl",
        instagram: "https://www.instagram.com/ulc_gov_pl/",
        linkedin: "https://www.linkedin.com/company/urzad-lotnictwa-cywilnego/",
    },
    warsaw: {
        url: "https://um.warszawa.pl/",
        facebook: "https://www.facebook.com/warszawa/",
        instagram: "https://www.instagram.com/miasto_warszawa/",
        youtube: "https://www.youtube.com/@miastostolecznewarszawa",
        x: "https://x.com/warszawa",
        tiktok: "https://www.tiktok.com/@miasto_warszawa",
    },
    pansa: {
        url: "https://www.pansa.pl",
        facebook: "https://www.facebook.com/PANSA.ANSP/",
        whatsapp: "https://www.whatsapp.com/channel/0029VajfsXV3LdQOutWukm2z",
        youtube: "https://www.youtube.com/channel/UCuIMWDnpz7B7McffrFqpVaA",
        instagram: "https://www.instagram.com/pansa_official/",
        x: "https://x.com/PANSA_PL",
        linkedin: "https://www.linkedin.com/company/polish-air-navigation-services-agency/",
    },
    warsawPolice: {
        url: "https://ksp.policja.gov.pl",
        facebook: "https://www.facebook.com/komendastolecznapolicji",
        instagram: "https://www.instagram.com/policja_ksp/",
        x: "https://x.com/Policja_KSP",
        youtube: "https://www.youtube.com/channel/UC0j1FVQxjdslocblW1PGdIg",
        tiktok: "https://www.tiktok.com/@komendastolecznapolicji",
    },
    sop: {
        url: "https://www.sop.gov.pl",
        facebook: "https://www.facebook.com/SOPRP/",
        x: "https://x.com/SOP_GOV_PL",
    },
    warszawaChroni: {
        url: "https://warszawa19115.pl/-/o-programie-warszawa-chroni-",
    },
} as const satisfies Record<string, SocialLinks>;

@Component({
    selector: "dtm-main-page-lib-where-you-can-fly",
    templateUrl: "./where-you-can-fly.component.html",
    styleUrls: ["../shared.scss", "./where-you-can-fly.component.scss"],
    providers: [
        {
            provide: IMAGE_LOADER,
            useValue: (config: ImageLoaderConfig) => {
                const fileName = config.src;
                const fileExtensionMatch = fileName.match(/^(?!.*\?onesize).*\.((?!svg\b)\w+)(?:$|\?)/i);
                const fileExtension = fileExtensionMatch?.[1];

                if (!fileExtension || !config.width || config.width <= 100) {
                    return fileName;
                }

                return fileName.replace(`.${fileExtension}`, `@2x.${fileExtension}`);
            },
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhereYouCanFlyComponent {
    protected readonly INFO_BROCHURE_URL = INFO_BROCHURE_URL;
    protected readonly DRONE_TOWER_APP_STORE_LINK = DRONE_TOWER_APP_STORE_LINK;
    protected readonly DRONE_TOWER_PLAY_STORE_LINK = DRONE_TOWER_PLAY_STORE_LINK;
    protected readonly PATRON_LINKS = PATRONS_LINKS;
}
